import React, { FC, useCallback, useState } from 'react';
import { Box } from '@chakra-ui/react';

import { useApi, useFetchData } from '@app/hooks';
import { Stand } from '@app/api/models';

import { useColumns } from './columns';
import SelectField from '../common/select-field';
import { Paper } from '../common';
import { QueryTable } from '../common/table';

const filterOptions = [
  { id: 1, name: 'Все' },
  { id: 2, name: 'В наличии' },
  { id: 3, name: 'Отсутствуют' },
];

const StandsTable: FC = () => {
  const columns = useColumns();
  const [activeFilter, setActiveFilter] = useState<EntityBase | undefined>({
    id: 1,
    name: 'Все',
  });

  const api = useApi();
  const [fetchData] = useFetchData({ method: api.stands.getStands });

  return (
    <>
      <Box mb={2}>
        <Paper>
          <Box  px={6} py={4} display="flex">
            <Box mr={2} minWidth={400}>
              <SelectField
                id="isDone"
                name="isDone"
                label="Наличие"
                options={filterOptions}
                value={activeFilter}
                onChange={setActiveFilter}
                clearable={false}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
      <QueryTable<Stand>
        title="Стойки"
        columns={columns}
        fetchData={useCallback((params) => fetchData({ ...params, filterRaw: { 
          ...params.filterRaw, 
          is_active: activeFilter.id === 1 
            ? undefined 
            : activeFilter.id === 2 ? '1' : '0'
        }}), [activeFilter])}
        key={activeFilter.id}
        canDownload
      />
    </>
  );
};

export default StandsTable;
